import * as React from 'react';
import { Field } from 'redux-form';

import { SegmentLabel } from '@acceligentllc/storybook';

import Textarea from 'af-fields/Textarea';

import WorkRequestUpsertFM from '../../formModel';
import { formSectionClass, formSectionClassColumn8, formSectionClassRow } from '../../helpers';

const JOB_HAZARD_SUMMARY_MAX_LENGTH = 600;

type Props = {
	jobHazardSummaryRef: React.MutableRefObject<Nullable<HTMLDivElement>>;
};

const JobHazardSummarySection: React.FC<Props> = ({ jobHazardSummaryRef }) => {
	return (
		<div className={formSectionClass} ref={jobHazardSummaryRef}>
			<SegmentLabel
				label="Job Hazard Summary"
				tooltip="An editable form for recording hazards identified for this job, helping ensure safe execution and compliance with site regulations."
			/>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn8}>
					<Field
						component={Textarea}
						maxCharacters={JOB_HAZARD_SUMMARY_MAX_LENGTH}
						name={WorkRequestUpsertFM.getAttributeName('hazardSummary')}
						placeholder="Enter text"
						rows={4}
						showMaxCharactersLabel={true}
					/>
				</div>
			</div>
		</div>
	);
};

export default React.memo(JobHazardSummarySection);
